import {
    apiRequest,
    refBknJabatanUmumList,
    syncDataBknJabatanUmum
} from "../../../../../../services/adapters/master/refBknJabatanUmumService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", refBknJabatanUmumList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    fetchSyncData = async (query, cancelToken) => {
        return await apiRequest("get", syncDataBknJabatanUmum, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
}

export default DataTableRepository